import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en.json';
import de from '@/locales/de.json';

// TODO: Replace static imports with Laravel API calls when backend is connected
// Example endpoint: GET /api/translations/{locale}
// Response format matches the JSON structure in locales/*.json

const resources = {
  en: { translation: en },
  de: { translation: de },
};

// Get saved language from localStorage or default to 'en'
const savedLanguage = typeof window !== 'undefined' 
  ? localStorage.getItem('language') || 'en' 
  : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

export const changeLanguage = (lang: 'en' | 'de') => {
  i18n.changeLanguage(lang);
  localStorage.setItem('language', lang);
};

export const getCurrentLanguage = () => i18n.language;
